import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// UI Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

function getCount(contact_string) {
  return contact_string ? contact_string.split(",").length : 0;
}

export default ({ onUserAction }) => [
  {
    dataField: "name_vch",
    text: "List Name",
    sort: true,
  },
  {
    dataField: "email_list_txt",
    text: "Email Contacts",
    sort: true,
    formatter: getCount,
  },
  {
    dataField: "text_list_txt",
    text: "Text Contacts",
    sort: true,
    formatter: getCount,
  },
  {
    dataField: "voice_list_txt",
    text: "Voice Contacts",
    sort: true,
    formatter: getCount,
    hidden: true,
  },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, seedList) => (
      <Fragment>
        <Link to="#" onClick={() => onUserAction("edit", seedList)}>
          <FontAwesomeIcon icon={faEdit} size="lg" color="primary" className="mr-3" />
        </Link>
        <Link to="#" onClick={() => onUserAction("delete", seedList)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
